(function () {
  'use strict';

  var rootSelector = '[data-at-sf-reviews]';
  var mountedAttribute = 'data-at-sf-reviews-mounted';

  function padNumber(number) {
    return String(number).padStart(2, '0');
  }

  function mount(root) {
    if (root.hasAttribute(mountedAttribute)) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('.at-sf-review'));
    if (!items.length) return;

    var controls = root.querySelector('[data-at-sf-reviews-controls]');
    var previousButton = root.querySelector('[data-at-sf-reviews-prev]');
    var nextButton = root.querySelector('[data-at-sf-reviews-next]');
    var currentCount = root.querySelector('[data-at-sf-reviews-current]');
    var totalCount = root.querySelector('[data-at-sf-reviews-total]');
    var status = root.querySelector('[data-at-sf-reviews-status]');
    var currentIndex = 0;
    var total = items.length;

    items.forEach(function (item, index) {
      item.setAttribute('role', 'group');
      item.setAttribute('aria-roledescription', 'review');
      item.setAttribute('aria-label', 'Review ' + (index + 1) + ' of ' + total);
    });

    function show(index, announce) {
      currentIndex = (index + total) % total;

      items.forEach(function (item, itemIndex) {
        item.hidden = itemIndex !== currentIndex;
      });

      if (currentCount) currentCount.textContent = padNumber(currentIndex + 1);
      if (status) status.textContent = announce ? 'Review ' + (currentIndex + 1) + ' of ' + total : '';
    }

    if (totalCount) totalCount.textContent = padNumber(total);
    if (previousButton) {
      previousButton.addEventListener('click', function () {
        show(currentIndex - 1, true);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        show(currentIndex + 1, true);
      });
    }
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') show(currentIndex - 1, true);
      if (event.key === 'ArrowRight') show(currentIndex + 1, true);
    });

    show(0, false);
    if (controls) controls.hidden = false;
    root.classList.add('at-sf-reviews--ready');
    root.setAttribute(mountedAttribute, 'true');
  }

  function mountWithin(scope) {
    if (!scope) return;

    var roots = [];
    if (scope.matches && scope.matches(rootSelector)) roots.push(scope);
    if (scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(rootSelector)));
    }
    roots.forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountWithin(document);
    });
  } else {
    mountWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountWithin(event.target);
  });
})();
